import { isTypeSimpleColumnSection } from '@platform/contentful';
import { Entry } from 'contentful';
import ContentfulSimpleColumn from './ContentfulSimpleColumn';

const ContentfulSimpleColumnSection = ({
  entry,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry: Entry<any, 'WITHOUT_UNRESOLVABLE_LINKS', 'en-US'> | undefined;
}) => {
  if (!entry || !isTypeSimpleColumnSection(entry)) {
    return null;
  }

  return (
    <div className='flex flex-col sm:flex-row'>
      {entry.fields.columns?.map((column) => (
        <ContentfulSimpleColumn key={column?.sys.id} entry={column} />
      ))}
    </div>
  );
};

export default ContentfulSimpleColumnSection;
